var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
export var DocumentLastActivityIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? '16' : _b, _c = _a.height, height = _c === void 0 ? '16' : _c;
    return (_jsx("svg", __assign({ width: width, height: height, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z", stroke: "#6B7280", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }) })));
};
